// extracted by mini-css-extract-plugin
module.exports = {"cardContainer":"card_cardContainer__13Qea","title":"card_title__3J7e1","inActive":"card_inActive__3abYT"};